
import { Toast } from "vant";
import { Component, Vue } from "vue-property-decorator";
import orderList from "./orderList.vue";
import navBar from "@/components/navBar.vue";
import { buyOrder } from "@/req/order";
@Component({
  components: {
    orderList,
    navBar,
  },
})
export default class Logout extends Vue {
  public status = "";
  public page = "1";
  public navList = [
    {
      id: 1,
      name: "我买到的",
    },
    {
      id: 2,
      name: "我卖出的",
    },
    // {
    //   id: 3,
    //   name: "指定我",
    // },
  ];
  public onClickLeft() {
    Toast("返回");
  }
  public beforeCreate() {
    (document as any)
      .querySelector("body")
      .setAttribute("style", "background-color:#f5f5f5");
  }
  public destroyed() {
    document.body.removeAttribute("style");
  }
  public mounted() {
    const obj: any = this.$fn.parseQuery(window.location.href);
    if (obj.type) {
      this.$store.state.order.active = obj.type;
    }
    (document as any)
      .querySelector("body")
      .setAttribute("style", "background-color:#f5f5f5");
  }

  public async getList() {
    const obj: any = {
      identity: this.$store.state.order.active,
      status: this.status,
      page: this.page,
      size: "20",
    };
    const res = await buyOrder(obj);
  }
  public showType(item) {
    // console.log(item);
    this.$store.state.order.active = item.id;
  }
}
